var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var root = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof global !== "undefined" && global;
function isConstructor(fn) {
  try {
    new fn();
  } catch (error) {
    return false;
  }
  return true;
}
if (typeof root.Event !== "function" || !isConstructor(root.Event)) {
  root.Event = function () {
    function Event(type, options) {
      this.bubbles = !!options && !!options.bubbles;
      this.cancelable = !!options && !!options.cancelable;
      this.composed = !!options && !!options.composed;
      this.type = type;
    }
    return Event;
  }();
}
if (typeof root.EventTarget === "undefined" || !isConstructor(root.Event)) {
  root.EventTarget = function () {
    function EventTarget() {
      this.__listeners = new Map();
    }
    EventTarget.prototype = Object.create(Object.prototype);
    EventTarget.prototype.addEventListener = function (type, listener, options) {
      if (arguments.length < 2) {
        throw new TypeError("TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ".concat(arguments.length, " present."));
      }
      var __listeners = this.__listeners;
      var actualType = type.toString();
      if (!__listeners.has(actualType)) {
        __listeners.set(actualType, new Map());
      }
      var listenersForType = __listeners.get(actualType);
      if (!listenersForType.has(listener)) {
        // Any given listener is only registered once
        listenersForType.set(listener, options);
      }
    };
    EventTarget.prototype.removeEventListener = function (type, listener, _options) {
      if (arguments.length < 2) {
        throw new TypeError("TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ".concat(arguments.length, " present."));
      }
      var __listeners = this.__listeners;
      var actualType = type.toString();
      if (__listeners.has(actualType)) {
        var listenersForType = __listeners.get(actualType);
        if (listenersForType.has(listener)) {
          listenersForType.delete(listener);
        }
      }
    };
    EventTarget.prototype.dispatchEvent = function (event) {
      var _this = this;
      if (!(event instanceof Event)) {
        throw new TypeError("Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.");
      }
      var type = event.type;
      var __listeners = this.__listeners;
      var listenersForType = __listeners.get(type);
      if (listenersForType) {
        var _iterator = _createForOfIteratorHelper(listenersForType.entries()),
          _step;
        try {
          var _loop = function _loop() {
            var _step$value = _slicedToArray(_step.value, 2),
              listener = _step$value[0],
              options = _step$value[1];
            try {
              if (typeof listener === "function") {
                // Listener functions must be executed with the EventTarget as the `this` context.
                listener.call(_this, event);
              } else if (listener && typeof listener.handleEvent === "function") {
                // Listener objects have their handleEvent method called, if they have one
                listener.handleEvent(event);
              }
            } catch (err) {
              // We need to report the error to the global error handling event,
              // but we do not want to break the loop that is executing the events.
              // Unfortunately, this is the best we can do, which isn't great, because the
              // native EventTarget will actually do this synchronously before moving to the next
              // event in the loop.
              setTimeout(function () {
                throw err;
              });
            }
            if (options && options.once) {
              // If this was registered with { once: true }, we need
              // to remove it now.
              listenersForType.delete(listener);
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      // Since there are no cancellable events on a base EventTarget,
      // this should always return true.
      return true;
    };
    return EventTarget;
  }();
}